import checkoutCoursierHeaderImg from "../styles/img/newCheckout/checkoutHeader.svg";

export const checkoutData = {
  302: {
    checkoutHeaderImg: checkoutCoursierHeaderImg,
    contractType: 'statut de micro-entrepreneur',
    steps: [
      {
        id: 1,
        status: 'first',
        content: 'Vous complétez le questionnaire d’informations',
      },
      {
        id: 2,
        status: 'next',
        content: 'Nous préparons votre dossier pour qu’il soit conforme',
      },
      {
        id: 3,
        status: 'upcoming',
        content: 'Nous déposons votre dossier auprès du greffe',
      },
      {
        id: 4,
        status: 'upcoming',
        content: 'Nous assurons la gestion des échanges avec le greffe',
      },
      {
        id: 5,
        status: 'beforeLast',
        content: 'Nous vous obtenons le Kbis',
      },
      {
        id: 6,
        status: 'last',
        content: 'Vous pouvez démarrer votre activité !',
      },
    ],
    upsellData: [
      {
        name: 'Assistance inscription Uber',
        priceHT: 12.5,
        priceTTC: 15,
        oldPrice: null,
        isSelected: false,
        description: [
          'En optant pour l’assistance inscription, nous vous aidons à terminer les démarches d’inscription sur le site d’Uber Eats.'
        ],
        includedOptions: [
          {
            heading: 'Guide étape par étape',
            text: 'Nous vous fournissons un guide étape par étape pour effectuer votre inscription sur le site d’Uber Eats.',
          },
          {
            heading: 'Assistance téléphonique',
            text:' Si vous rencontrez des soucis durant votre inscription, un conseiller vous guide et répond à vos questions en direct.',
          }
        ],
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/constants/checkoutData.js